module.exports = __webpack_public_path__ + "static/media/LGCP01.7de6645b.jpg";